import { render, staticRenderFns } from "./PedidosTraslados.vue?vue&type=template&id=8b5c3db2&scoped=true"
import script from "./PedidosTraslados.vue?vue&type=script&lang=js"
export * from "./PedidosTraslados.vue?vue&type=script&lang=js"
import style0 from "./PedidosTraslados.vue?vue&type=style&index=0&id=8b5c3db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5c3db2",
  null
  
)

export default component.exports